import { render, staticRenderFns } from "./UserGroupResourcesACL.vue?vue&type=template&id=68b31474&scoped=true&"
import script from "./UserGroupResourcesACL.vue?vue&type=script&lang=ts&"
export * from "./UserGroupResourcesACL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b31474",
  null
  
)

export default component.exports